export const keyword = [
  "course",
  "e-learning",
  "e-learning platform",
  "e-learning in education",
  "e-learning paragraph",
  "e-learning portal",
  "e-library",
  "e-learning online",
  "e-learning for kids",
  "e-learning modules",
  "e-learning institue",
  "online-education",
  "online course",
  "onilne course bd",
  "onilne course in bangladesh",
  "online course platform",
  "online course with free certificate",
  "online course club",
  "online courses free",
  "online courses for education degree",
  "online course providers",
  "online course template",
  "course outline",
  "course registration",
  "best online course platforms",
  "best online course",
  "best online course in bangladesh",
  "best online course site",
  "best online course platforms with certificate",
  "best online course with free certificate",
  "skill development",
  "skill development training center",
  "skill development courses",
  "skill development courses list",
  "skill development institue",
  "skill development for mobile game & application",
  "skill development programme",
  "learning and earning",
  "learning outcomes",
  "education",
  "education courses",
  "education courses online",
  "education courses for teachers",
  "my learning",
  "digital marketing course",
  "of course",
  "learn",
];
